import type { ApiRequest } from '@zurich-framework/core/api';
import type {
  PostVSGAGutachtenRequestBody,
  PostVSGAGutachtenResponse,
} from '@zurich/api/legacy';

export const postVSGAGutachtenPublic: ApiRequest<
  PostVSGAGutachtenResponse,
  false,
  PostVSGAGutachtenRequestBody
> = {
  source: 'app',
  route: '/vorschadengutachten/submission',
  method: 'POST',
};
